/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsRight = createReactComponent("arrows-right", "IconArrowsRight", [
  ["path", { d: "M21 17l-18 0", key: "svg-0" }],
  ["path", { d: "M18 4l3 3l-3 3", key: "svg-1" }],
  ["path", { d: "M18 20l3 -3l-3 -3", key: "svg-2" }],
  ["path", { d: "M21 7l-18 0", key: "svg-3" }]
]);

export { IconArrowsRight as default };
//# sourceMappingURL=IconArrowsRight.js.map
